import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/baseUi/select"
import { Text } from "@/components/ui/baseUi/text"

type YearPickerProps = {
  /** Currently selected year */
  year: number
  /** Called when user picks a year — passes as string to match Select contract */
  onYearChange: (yearValue: string) => void
  /** Array of years to display in the dropdown */
  years: number[]
  /** Optional className for the SelectTrigger */
  className?: string
} & React.ComponentProps<typeof Select>

export function YearPicker({ year, onYearChange, years, className, ...props }: YearPickerProps) {
  return (
    <Select value={String(year)} onValueChange={(value) => onYearChange(String(value ?? ""))} {...props}>
      <SelectTrigger className={className ?? "w-auto gap-1 border-none bg-surface-background px-4 py-2"}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent className="rounded-2xl border-none bg-surface-background-float">
        {years.map((y) => (
          <SelectItem key={y} value={String(y)} className="rounded-xl">
            <Text fontStyle="LM">{y}</Text>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
